export default [
  {
    component: 'CNavItem',
    name: 'Exam Checker',
    to: '/exam-checker',
    icon: 'cilTask',
    badge: {
      color: 'info',
    },
  },
  {
    component: 'CNavItem',
    name: 'Exam Type',
    to: '/exam-types',
    icon: 'cilListRich',
    badge: {
      color: 'info',
    },
  },
  {
    component: 'CNavItem',
    name: 'Context',
    to: '/context',
    icon: 'cil-newspaper',
    badge: {
      color: 'info',
    },
  },
  {
    component: 'CNavItem',
    name: 'User',
    to: '/user',
    icon: 'cilUser',
    badge: {
      color: 'info',
    },
  },
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cilSpeedometer',
    badge: {
      color: 'info',
    },
  },
]
